export function getVariantExistingStyle(variantId: string, renderingId: string) {
  return document.querySelector(
    `.static-variant-visible-style[data-variant-id="${variantId}"][data-rendering-id="${renderingId}"]`,
  )
}
